// Componente per la gestione Toolbar
import React from 'react';
import PropTypes from 'prop-types';
import { get, set } from './Storage';
import Badge from 'material-ui/Badge';
import IconButton from 'material-ui/IconButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import axios from 'axios';
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'ToolbarIcontComponent';
var styles = AppSettings.styles;

class ToolbarIcon extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTab = this.handleTab.bind(this);

        this.state = {
            balance: "",
            fido: "",
            bonusBalance:"",
            showBalance: false
        }

        // this.handleToggleBalance = this.handleToggleBalance.bind(this);
    }

    componentDidMount() {
        if (AppSettings['balanceOpened'] && AppSettings.device != "mobile") {
            let data = this.context.getExternalToolbarBalance();
            if(data == null){
                this.refreshBalance();
            }
            else{
                this.setState({
                    balance: data.balance,
                    bonusBalance: data.bonusBalance,
                    fido: data.fido,
                    showBalance: true
                });
            }
        }
    }

    componentWillReceiveProps(props){
        // if(this.state.balance != props.balance){
        //     this.setState({
        //         balance: props.balance,
        //         bonusBalance:props.bonusBalance,
        //         showBalance: true,
        //         fido: props.fido,
        //     });
        // }
    }

    handleTab(tab, event) {
        this.props.handleTab(tab);
    }
    
    refreshBalance() {
        this.setState({
            showBalance: true,
            balance: '---'
        });
        var balance = "--";
        var bonusBalance="0";
        var fido = '';
        var url = AppSettings['env'].urlUserBoxGetBalance;
        this.context.setBalanceData(null);
        axios.get(url)
            .then(({ data, status, statusText }) => {
                this.context.setExternalToolbarBalance(data);
                if (data.errors.length == 0) {
                    this.context.setBalanceData(data);
                    balance = data.balance;
                    if(data.bonusBalance !=null){
                        bonusBalance=data.bonusBalance;
                    }
                    if(data.fido !== 0 ){
                        fido = data.fidoStr;
                    }                    
                    try {
                        document.querySelectorAll("[data-ub-balance]").forEach(function (el) { el.innerHTML = balance });
                        document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = fido });
                        document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = bonusBalance });
                    }
                    catch (e) { }
                }
                this.setState({
                    balance: balance,
                    bonusBalance:bonusBalance,
                    showBalance: true,
                    fido: fido,
                });
            })

            .catch(({ data, status, statusText }) => {
                this.setState({
                    balance: "--",
                    bonusBalance:"",
                    showBalance: true,
                    fido: ''
                });
            });
    }

    render() {
        let notification = false;
        let countNotification = this.props.countNews + this.props.countCoupon + this.props.countMission;           
        if (countNotification > 0) {
            badgeContent = countNotification;
            notification = true;
        }

        return (
            <div className="user-box-toolbar user-box-toolbar-icon">
                <ul id="user-box-toolbar-list">
                    {AppSettings["perms"].tabProfile ?
                        <li onClick={this.handleTab.bind(this, "profile")} id="user-box-profilo">

                            {notification ?
                                <Badge badgeContent={badgeContent}
                                    style={styles.badgeNotifications}
                                    badgeStyle={styles.badgeStyle}>
                                    <IconButton iconClassName="fa-mg fa-mg-user-2"
                                        iconStyle={styles.topIconStyle}  />
                                </Badge>
                                :
                                <IconButton iconClassName="fa-mg fa-mg-user-2"
                                    iconStyle={styles.topIconStyle}  />
                            }
                        </li>
                        : null}
                    {this.state.showBalance ?
                        <li id="user-box-balance">{this.state.balance}</li>                     
                                               
                        : ""}
                    {this.state.showBalance ?//&& this.state.bonusBalance!="0" && this.state.bonusBalance!="€ 0,00" ?
                        <li id="user-box-balance">{this.state.bonusBalance}</li>                        
                        : ""}                    
                                        
                </ul>
            </div>
        )
    }
}

ToolbarIcon.displayName = componentName;

// PropTypes validation
ToolbarIcon.propTypes = {
    countNews: PropTypes.number,
    countCoupon: PropTypes.number,
    balance: PropTypes.string,    
    bonusBalance: PropTypes.string,
    countMission: PropTypes.number

};

ToolbarIcon.contextTypes = {
    setExternalToolbarBalance:PropTypes.func,
    getExternalToolbarBalance:PropTypes.func,
    setBalanceData: PropTypes.func
}
// default props
ToolbarIcon.defaultProps = {
    switchToolbar: function () {
    }
};

export default ToolbarIcon;